import { Box, Button, Stack, TextField } from '@mui/material';
import { DateTime } from 'luxon';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import RefreshTimer from './RefreshTimer';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { fetchCustomerCycles, fetchCustomers, selectFacilitiesDropdown, selectFacilitiesDropdownByCustomer, setBiochallengeInfo, setDeviceConfigIds, setFromDate, setSelectedCustomer, setSelectedFacilities, setToDate } from '../summaryDashboardSlice';
import CustomerAutoComplete from 'src/components/material/Dropdowns/CustomerAutoComplete';
import FacilitiesAutoComplete from 'src/components/material/Dropdowns/FacilitiesAutoComplete';
import { useHistory } from 'react-router-dom';

const Toolbar = ({ useCustomerDropdown }) => {
    const dispatch = useDispatch();
    const history = useHistory();

    // @ts-ignore
    const { toDate, fromDate, selectedFacilities, selectedCustomer, customerDropdown, } = useSelector((store) => store.summarydashboard);
    const facilityDropdown = useSelector((store) => selectFacilitiesDropdown(store.summarydashboard));

    const submit = () => {
        // @ts-ignore
        dispatch(fetchCustomerCycles());
        // @ts-ignore
        //dispatch(fetchBiochallengeInfo());
    };

    // useEffect(() => {
    //     if (customerDropdown.length === 0) {
    //         dispatch(fetchCustomers());
    //     }
    // }, []);

    const toDateObj = DateTime.fromISO(toDate);
    const fromDateObj = DateTime.fromISO(fromDate);

    const handleCustomerChange = (newValue) => {
        dispatch(setSelectedCustomer(newValue))
        dispatch(setSelectedFacilities([]));
        dispatch(setBiochallengeInfo([]));
        dispatch(setDeviceConfigIds([]));
        history.push(`/sa/summary-dashboard/v2/${newValue ? newValue.id : ""}`);
    }

    return (
        <Box>
            <RefreshTimer />
            <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={{ xs: 2, lg: 4 }}
                sx={{ mt: 2, mb: 4 }}
                alignContent={"center"}
                justifyContent={"space-between"}>

                <Stack direction={{ xs: "column", md: "row" }} spacing={1} sx={{ justifyContent: "center", alignItems: "center" }} alignContent={"space-evenly"}>
                    {useCustomerDropdown && <CustomerAutoComplete selectedCustomer={selectedCustomer} customerDropdown={customerDropdown} setSelectedCustomer={handleCustomerChange} />}
                    <FacilitiesAutoComplete selectedFacilities={selectedFacilities} selectedCustomer={selectedCustomer} facilityDropdown={facilityDropdown} setSelectedFacilities={(newValue) => dispatch(setSelectedFacilities(newValue))} fetchFacilities={() => { }} />
                </Stack>
                <LocalizationProvider dateAdapter={AdapterLuxon}>
                    <Stack
                        direction={{ xs: "column", sm: "row" }}
                        sx={{ justifyContent: "center", alignItems: "center" }}
                        spacing={1}>
                        <DatePicker
                            label="From"
                            mask="__/__/____"
                            value={fromDateObj}
                            openTo="day"
                            views={["year", "month", "day"]}
                            disableFuture={true}
                            onChange={(newValue) => {
                                dispatch(setFromDate(newValue.toISODate()));
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        />

                        <DatePicker
                            label="To"
                            mask="__/__/____"
                            value={toDateObj}
                            openTo="day"
                            views={["year", "month", "day"]}
                            disableFuture={true}
                            minDate={DateTime.fromISO(fromDate)}
                            onChange={(newValue) => {
                                dispatch(setToDate(newValue.toISODate()));
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        />

                        <Button variant="contained" onClick={submit} size="large" >
                            Submit
                        </Button>
                    </Stack>
                </LocalizationProvider>
            </Stack>
        </Box>
    );
}

export default Toolbar
